import { render, staticRenderFns } from "./Preferential.vue?vue&type=template&id=6bd03e46&scoped=true&"
import script from "./Preferential.vue?vue&type=script&lang=js&"
export * from "./Preferential.vue?vue&type=script&lang=js&"
import style0 from "./Preferential.vue?vue&type=style&index=0&id=6bd03e46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd03e46",
  null
  
)

export default component.exports